import { MPointStationType } from "./mPointStationType";
import Norm from "./norm";
import Limits from "./limits";
import { AlarmLevel } from "./forecastResult";
export default class MPoint {
    constructor() {
        this.name = "";
        this.stationType = MPointStationType.Undefined;
        this.pqStatus = AlarmLevel.NoValue;
        this.notificationStatus = AlarmLevel.NoValue;
        this.norm = new Norm();
        this.limits = new Limits();
        this.forecastResults = new Map();
        this.forecasts = new Map();
        this.histories = new Map();
        this.trends = new Map();
        this.nowValues = new Map();
    }
    toString() {
        return `[${this.id} ${this.name}]`;
    }
}
